export var ThemePaletteType;

(function (ThemePaletteType) {
  ThemePaletteType["Light"] = "light";
  ThemePaletteType["Dark"] = "dark";
})(ThemePaletteType || (ThemePaletteType = {}));

export var ThemePaletteVariant;

(function (ThemePaletteVariant) {
  ThemePaletteVariant["GreenLight"] = "green-light";
  ThemePaletteVariant["Green"] = "green";
  ThemePaletteVariant["Blue"] = "blue";
  ThemePaletteVariant["Orange"] = "orange";
  ThemePaletteVariant["Purple"] = "purple";
})(ThemePaletteVariant || (ThemePaletteVariant = {}));